module.exports = __webpack_public_path__ + "static/logo-84f34275d8042925cbe17dcf21cb83f2.png";